import { get } from '.';

export async function getNews() {
	const articles: any = (await get(`/news`)).data;

	return articles;
}
